module.exports = __webpack_public_path__ + "assets/img/title-29d0a744.png";